import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import InboxIcon from "@mui/icons-material/Inbox";

export default function EmptyState({ icon, title = "No data", description, cta, compact = false }) {
  const IconComp = icon || <InboxIcon sx={{ fontSize: compact ? 36 : 56, color: "text.disabled" }} />;
  return (
    <Stack alignItems="center" justifyContent="center" spacing={1} sx={{ py: compact ? 2 : 6, textAlign: "center" }}>
      <Box>{IconComp}</Box>
      <Typography variant={compact ? "subtitle2" : "h6"} color="text.secondary">{title}</Typography>
      {description && <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 360 }}>{description}</Typography>}
      {cta && <Box mt={1}>{cta}</Box>}
    </Stack>
  );
}
